module.exports = __webpack_public_path__ + "static/img/ecaray_about_introduction_honor15.5ab47580.png";